const routes = [
  {
    path: '/stock',
    component: () => import('./pages/Stock.vue'),
    children: [
      {
        path: '',
        name: 'ModulesStock',
        component: () => import('./pages/StockItems.vue'),
      },
      {
        path: 'my',
        name: 'ModulesStockMy',
        component: () => import('./pages/StockMy.vue'),
      },
    ],
    meta: {
      title: 'Биржа модулей',
    },
  },
  {
    path: '/',
    component: () => import('./pages/ModulesManagement.vue'),
    children: [
      {
        path: '',
        name: 'ModulesManagementLead',
        component: () => import('./pages/ModulesManagementLead.vue'),
        meta: {
          title: 'Модули',
        },
      },
      {
        path: 'create',
        name: 'ModuleCreate',
        component: () => import('./pages/ModulesCreate.vue'),
        meta: {
          title: 'Создание модуля',
          breadcrumbs: {
            parent: 'ModulesManagementLead',
          },
          authorize: [],
        },
      },
      {
        path: ':id',
        name: 'ModuleView',
        component: () => import('./pages/ModuleView.vue'),
        children: [
          {
            path: 'escort',
            name: 'ModuleViewEscort',
            component: () => import('./pages/ModuleViewEscort.vue'),
            meta: {
              breadcrumbs: {
                parent: 'ModulesManagementLead',
              },
              title: 'Ведение модуля',
            },
          },
          {
            path: 'units',
            name: 'ModuleViewUnits',
            component: () => import('./pages/ModuleViewUnits.vue'),
            meta: {
              breadcrumbs: {
                parent: 'ModulesManagementLead',
              },
              title: 'Темы модуля',
            },
          },
          {
            path: 'subscribers',
            name: 'ModuleViewSubscribers',
            component: () => import('./pages/ModuleViewSubscribers.vue'),
            meta: {
              breadcrumbs: {
                parent: 'ModulesManagementLead',
              },
              title: 'Подписки на модуль',
            },
          },
          {
            path: 'subscribers/:subId',
            name: 'ModuleViewSubscribersView',
            component: () => import('./pages/ModuleViewSubscribersView.vue'),
            meta: {
              breadcrumbs: {
                parent: 'ModuleViewSubscribers',
              },
              title: 'Организация',
            },
          },
          {
            path: 'analytic',
            name: 'ModuleViewAnalytic',
            component: () => import('./pages/ModuleViewAnalytic.vue'),
            meta: {
              breadcrumbs: {
                parent: 'ModulesManagementLead',
              },
              title: 'Аналитика модуля',
            },
          },
          {
            path: 'settings',
            name: 'ModuleViewSettings',
            component: () => import('./pages/ModuleViewSettings.vue'),
            meta: {
              breadcrumbs: {
                parent: 'ModulesManagementLead',
              },
              title: 'Настройки модуля',
            },
          },
          {
            path: 'gpt-settings',
            name: 'ModuleGPTSettings',
            component: () => import('./pages/ModuleGPTSettingsPage.vue'),
            meta: {
              title: 'Настройки нейросети',
              type: 'course_module',
            },
          },
        ],
      },
    ],
  },
];

export default routes;
